module.exports = __webpack_public_path__ + "img/close.4bba6013.png";